import React from "react";
import { Link } from "react-router-dom";
import "./otpSubscription.css";
import useOtpSubscription from "./customHook";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { Input as BaseInput } from "@mui/base/Input";
import { styled } from "@mui/system";
import PropTypes from "prop-types";

function OTP({ separator, length, value, onChange, inputRefs, onKeyDown, onChangeInput, onClick, onPaste }) {
  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
      {new Array(length).fill(null).map((_, index) => (
        <React.Fragment key={index}>
          <BaseInput
            slots={{ input: InputElement }}
            aria-label={`Digit ${index + 1}`}
            slotProps={{
              input: {
                ref: (ele) => { inputRefs.current[index] = ele },
                onKeyDown: (e) => onKeyDown(e, index),
                onChange: (e) => onChangeInput(e, index),
                onClick: (e) => onClick(e, index),
                onPaste: (e) => onPaste(e, index),
                value: value[index] ?? "",
              }
            }}
          />
          {index === length - 1 ? null : separator}
        </React.Fragment>
      ))}
    </Box>
  );
}

OTP.propTypes = {
  length: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  separator: PropTypes.node,
  value: PropTypes.string.isRequired,
};

function OtpSubscription() {
  const {
    otp,
    setOtp,
    inputRefs,
    handleKeyDown,
    handleChange,
    handlePaste,
    handleClick,
    onSubmit,
    state
  } = useOtpSubscription(6);

  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">OTP Subscription</h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item"><Link to="/">Home</Link></li>
          <li className="breadcrumb-item active">OTP Subscription</li>
        </ol>
      </Container>
      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">OTP</h6>
          <h1 className="mb-3"><span className="text-secundary">Subscription</span></h1>
        </Grid>
        <Grid className="row">
          <Container component="main" maxWidth="sm">
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Grid className="d-flex justify-content-center align-items-center flex-column">
                <Typography variant="h4" className="mb-3 otp-ttl">We have e-mailed an OTP to {state?.data?.email}</Typography>
                <OTP
                  separator={<span>-</span>}
                  value={otp}
                  onChange={setOtp}
                  inputRefs={inputRefs}
                  onKeyDown={handleKeyDown}
                  onChangeInput={handleChange}
                  onClick={handleClick}
                  onPaste={handlePaste}
                  length={6}
                />
              </Grid>
            </Box>
            <Grid className="d-flex justify-content-center align-items-center">
              <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2, p: 2 }} onClick={onSubmit}>
                Verify
              </Button>
            </Grid>
          </Container>
        </Grid>
      </Container>
    </>
  );
}

export default OtpSubscription;

const InputElement = styled("input")(
  ({ theme }) => `
    width: 40px;
    font-weight: 400;
    padding: 8px 0px;
    border-radius: 8px;
    text-align: center;
    border: 1px solid #000;
    box-shadow: 0px 2px 4px ${theme.palette.mode === "dark" ? "rgba(0,0,0, 0.5)" : "rgba(0,0,0, 0.05)"};

    &:hover {
      border-color: grey;
    }
    &:focus {
      border-color: #f00;
      box-shadow: 0 0 0 3px ${theme.palette.mode === "dark" ? "#888" : "#ddd"};
    }
    &:focus-visible {
      outline: 0;
    }
  `
);
